import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
  currentSlide = 0;
  showTitle = false;
  showSubtitle = false;
  autoPlayInterval: any;
  displayedTitle = '';
  displayedSubtitle = '';
  typingInterval: any;

  slides = [
    {
      image: 'assets/img/site1.png',
      title: 'Seu negócio merece um site à altura!',
      subtitle: 'Criamos experiências digitais que transformam visitantes em clientes reais'
    },
    {
      image: 'assets/img/site2.png',
      title: 'Da ideia ao ar em tempo recorde!',
      subtitle: 'Landing pages, sites empresariais e e-commerces desenvolvidos com tecnologia moderna'
    }
  ];

  feedbacks = [
    {
      name: 'Vinicius BarberShop',
      role: 'Barbearia',
      text: 'Antes eu dependia só do Instagram pra receber clientes. Depois do site, comecei a receber mensagens direto pelo WhatsApp de pessoas que me acharam no Google. Valeu muito a pena.',
      stars: 4.5
    },
    {
      name: 'Isadora Luchtenberg',
      role: 'Loja de roupas femininas',
      text: 'Achei que ia ser complicado, mas o Nícolas explicou tudo certinho e entregou antes do prazo. O site ficou exatamente do jeito que eu queria, moderno e fácil de navegar.',
      stars: 5
    },
    {
      name: 'Ricardo Junior',
      role: 'Personal trainer',
      text: 'Precisava de uma landing page pra capturar alunos e o resultado superou o que eu esperava. Já na primeira semana tive contatos novos vindo pelo site.',
      stars: 4.9
    },
    {
      name: 'Yasmin',
      role: 'Clínica de estética',
      text: 'O site ficou lindo e profissional. Meus clientes sempre comentam como ficou bonito. Aumentou muito a credibilidade do meu negócio.',
      stars: 5
    },
    {
      name: 'João Paulo',
      role: 'Escritório de advocacia',
      text: 'Precisava transmitir seriedade e confiança. O resultado ficou exatamente assim — elegante, direto ao ponto e com tudo funcionando perfeitamente.',
      stars: 4.8
    }
  ];

  services = [
    {
      image: 'assets/img/mister.png',
      title: 'Landing',
      highlight: 'Pages',
      description: 'Páginas de alta conversão criadas para transformar visitantes em leads e vendas reais.',
      fragment: 'landing-pages'
    },
    {
      image: 'assets/img/login-j$a.png',
      title: 'Sites',
      highlight: 'Empresariais',
      description: 'Presença digital profissional para sua marca se destacar e conquistar novos clientes.',
      fragment: 'sites-empresariais'
    },
    {
      image: 'assets/img/meteora.png',
      title: 'Lojas',
      highlight: 'Virtuais',
      description: 'E-commerces completos e prontos para vender, com design moderno e experiência fluida.',
      fragment: 'lojas-virtuais'
    },
    {
      image: 'assets/img/academy.png',
      title: 'Design &',
      highlight: 'Identidade',
      description: 'Visual marcante e identidade consistente para sua marca causar impacto desde o primeiro olhar.',
      fragment: 'design-identidade'
    }
  ];

  getStars(rating: number): string[] {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      if (i <= Math.floor(rating)) {
        stars.push('full');
      } else if (rating % 1 >= 0.5 && i === Math.ceil(rating)) {
        stars.push('half');
      } else {
        stars.push('empty');
      }
    }
    return stars;
  }

  constructor() { }

  ngOnInit(): void {
    this.startTypingAnimation();
    this.startAutoPlay();
    this.muteHeroVideo();
  }

  muteHeroVideo(): void {
    setTimeout(() => {
      const video = document.querySelector('.hero-video') as HTMLVideoElement;
      if (video) {
        video.muted = true;
        video.volume = 0;
      }
    }, 100);
  }

  ngOnDestroy(): void {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
    }
    if (this.typingInterval) {
      clearInterval(this.typingInterval);
    }
  }

  startTypingAnimation(): void {
    this.showTitle = false;
    this.showSubtitle = false;
    this.displayedTitle = '';
    this.displayedSubtitle = '';

    if (this.typingInterval) {
      clearInterval(this.typingInterval);
    }

    this.showTitle = true;
    this.displayedTitle = this.slides[this.currentSlide].title;

    this.showSubtitle = true;
    this.typeSubtitle();
  }

  typeSubtitle(): void {
    const subtitle = this.slides[this.currentSlide].subtitle;
    let index = 0;
    this.displayedSubtitle = '';

    this.typingInterval = setInterval(() => {
      if (index < subtitle.length) {
        this.displayedSubtitle += subtitle.charAt(index);
        index++;
      } else {
        clearInterval(this.typingInterval);
      }
    }, 30);
  }

  nextSlide(): void {
    this.currentSlide = (this.currentSlide + 1) % this.slides.length;
    this.startTypingAnimation();
  }

  prevSlide(): void {
    this.currentSlide = this.currentSlide === 0 ? this.slides.length - 1 : this.currentSlide - 1;
    this.startTypingAnimation();
  }

  goToSlide(index: number): void {
    this.currentSlide = index;
    this.startTypingAnimation();
  }

  startAutoPlay(): void {
    this.autoPlayInterval = setInterval(() => {
      this.nextSlide();
    }, 6000);
  }

}
